import React, { useState,useEffect } from "react";
import { API_URL,RESPONSE_SUCCESS } from '../../GlobalConstents.js';
import { Link, useNavigate, useParams } from "react-router-dom";
import API from '../../Api.js';
import { toast } from 'react-toastify';
import {RouteChanged,ROUTE_EXAM_SINGLE_REPORT } from '../../RouteConstents';

const ExamReportDetails = () => {
    
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [examTitle, setExamTitle] = useState('');
    const [totalQuestionCount, setTotalQuestionCount] = useState(0);
    const [questionList, setQuestionList] = useState([]);
    const [currentQuestion, setCurrentQuestion] = useState(1);
    const [showNavigationView, setShowNavigationView] = useState(0);
    const [selectedOption, setSelectedOption] = useState([]);
    const [testID, setTestID] = useState(0);
    const [testReportID, setTestReportID] = useState(0);
   // const [takenTime, setTakenTime] = useState(5);
    
    const [uncheckClass, setUncheckClass] = useState('');
    
    const QuestionPerPage = 1; // Set the number of items per page

    const { string } = useParams();
    
    useEffect(
        () => {
        document.body.classList.add('theme-red');
        document.body.classList.remove('login-page');
        document.body.classList.remove('overlay-open');
        showExamDetails()
    },[]); 

    const totalPages = Math.ceil(totalQuestionCount / QuestionPerPage);

    const showExamDetails = async () => {

        let objValue =  {"method_name":"examAnalysis","test_report_id":string,"exam_view":1}

        setIsLoading(true);
        await API.post(API_URL,objValue).then(function (response) {
            setIsLoading(false);
            if (response.status === RESPONSE_SUCCESS) {
                if (response.data.status === "success") {
                    setExamTitle(response.data.examInfo.test_series_title)   
                    setTotalQuestionCount(response.data.examInfo.total_questions)
                    // setQuestionList(response.data.examInfo.question_list)
                    setTestID(response.data.examInfo.test_series_id)
                    setTestReportID(response.data.examInfo.test_report_id)
                   // setTakenTime(60 * response.data.examInfo.total_time)
                    
                    let questionList = response.data.examInfo.question_list;
                    let optionArr = [];
                    let test_id = response.data.examInfo.test_series_id;

                    questionList.map( (item,key) => {
                        optionArr[key] = {'test_id':test_id,'question_id':item.question_id,'option_id':''};    
                        setSelectedOption(optionArr);

                        let qSr = key + 1;  
                        questionList[key]['question_sr_no'] = qSr;
                        questionList[key]['test_id'] = test_id;
                        questionList[key]['user_select_option'] = '';
                        
                    });

                    setQuestionList(questionList); 

                } else {
                    toast.error(response.data.message);
                }
            }

        }).catch(function (error) {
           // ForceLogoutUser(error);
        });

    }

    const goToQuestion = (value) => {
        document.body.classList.remove('overlay-open');
        setShowNavigationView(0); 
        setCurrentQuestion(value);
    }

    const showNavigation = (e) => {
        if(showNavigationView === 0) {
            document.body.classList.add('overlay-open');
            setShowNavigationView(1);
        } else {
            document.body.classList.remove('overlay-open');
            setShowNavigationView(0); 
        } 
    }

    const startIndex = (currentQuestion - 1) * QuestionPerPage;
    const endIndex = startIndex + QuestionPerPage;
    const currentQuestionData = questionList.slice(startIndex, endIndex);

    
    const handlePageChange = (page) => {
        if (page < 1) {
            setCurrentQuestion(1);
        } else if (page > totalPages) {
            setCurrentQuestion(totalPages);
        } else {
            setCurrentQuestion(page);
        }
    };

    const tickAsMark = (questionId,OptionId) => {
        questionList.map( (item,key)=> {
            if(item.question_id === questionId) {
                questionList[key]['user_select_option'] = OptionId; 
            } else {
                questionList[key] = item;     
            }
        });

        setUncheckClass('label_uncheck_'+questionId);
       
        setQuestionList(questionList); 
    }

    const checkSelectOption = (questionId,OptionId) => {
        selectedOption.map( (item,key)=> {
            if(item.question_id === questionId && item.option_id === OptionId) {
                const updatedResponses = {
                    ...selectedOption,
                    [key]: OptionId,
                  };
                  setSelectedOption(updatedResponses);       
            }
        });
        return false;
    }    
    
    const backNow  = async () => {
    
        let newURL = RouteChanged(ROUTE_EXAM_SINGLE_REPORT,string)
        navigate(newURL);
       
  
    }

    
   
    // useEffect(() => {
    //     if (takenTime >= 0) {
    //       const secondsLeft = setInterval(() => {
    //         setTakenTime((c) => c - 1);
    //         let timeLeftVar = secondsToTime(takenTime);
    //         setHour(timeLeftVar.h);
    //         setMinute(timeLeftVar.m);
    //         setSecond(timeLeftVar.s);
    //       }, 1000);
    //       return () => clearInterval(secondsLeft);
    //     } else {
          
    //       //timeUp();
    //     }
    // }, [takenTime]);
    
    
    
    return (
        <>
        <div className="overlay"></div>
        <nav className="examPage navbar">
            <div className="container-fluid">
                <div className="navbar-header">
                    <span onClick={showNavigation} className="bars"></span>
                    <Link className="navbar-brand" to={'#'}>{examTitle}</Link>
                </div>
                
            </div>
        </nav>
        <section>
            <aside id="leftsidebar" className="examPage sidebar">
                <div className="user-info bg-cyan" style={ {height:"180px"}}>
                    <div className="row clearfix">
                        <div className="col-xs-12">
                            <button type="button" className="btn btn-default waves-effect mr-5 exam_option_wh_30">&nbsp;</button> No Answered<br/><br/>
                            <button type="button" className="btn btn-success waves-effect mr-5 exam_option_wh_30">&nbsp;</button> Corrent Answered <br/><br/>
                            <button type="button" className="btn btn-danger waves-effect mr-5 exam_option_wh_30">&nbsp;</button> Wrong Answered <br/>
                        </div>
                    </div>
                </div>
                
                <div className="menu">
                    <div className="examOption">
                        <div className="row clearfix text-center">
                            {
                                questionList && questionList.map((item) => {
                                    let optionClass = ''; 
                                    if(item.attempted_status === 0) {
                                        optionClass = 'btn btn-default waves-effect mr-5'; 
                                    } else if(item.attempted_status === 1) {
                                        optionClass = 'btn btn-success waves-effect mr-5'; 
                                    } else {
                                        optionClass = 'btn btn-danger waves-effect mr-5'; 
                                    }

                                    return (
                                        <>
                                            <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 text-center" >
                                                <button type="button"  className={optionClass} onClick={() => {goToQuestion(item.question_sr_no, item.question_id)}}>{item.question_sr_no}</button>
                                            </div>
                                        </>
                                    )
                                })
                            } 
                        </div>
                    </div>
                </div>
                <hr/>
                <div className="row text-center">
                    <button type="button" className="btn bg-indigo waves-effect" onClick={() => { backNow()}} >Back</button>
                </div>
            </aside>
        </section>
        
        <section className="content">
            <div className="container-fluid">
                {/*<div className="text-center">
                    {hour < 9 ? "0" + hour : hour} : {minute < 9 ? "0" + minute : minute} : {second < 9 ? "0" + second : second}
                </div>
                 <select>
                    <option value="english">English</option>
                    <option value="Hindi">Hindi</option>
                </select> */}
                {
                    currentQuestionData && currentQuestionData.map((item,key) => {

                        let showExplanation = '';
                        if(item.explanation_english !== '' || item.explanation_hindi !== '' || item.explanation_image_url !== '' || item.explanation_english !== '' ) {
                            showExplanation = 1;    
                        }

                        return (
                            <>
                            <div className="block-header">
                                <h2>Question. {currentQuestion}</h2>
                            </div>

                            <div className="row clearfix" key="{key}">

                                <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                    <div dangerouslySetInnerHTML={{ __html: item.question_in_english }} />
                                    <div dangerouslySetInnerHTML={{ __html: item.question_in_hindi }} />
                                    <hr/>
                                    <ul className="list-group">
                                    { 
                                       item.options && item.options.map((optionItem,k) => {

                                            let optionClass = 'list-group-item list-group-item-default'; 
                                            
                                            if(item.attempted_status === 0 && item.attempted_option === '') {
                                                optionClass = 'list-group-item list-group-item-default'; 
                                            } 

                                            if(item.attempted_status === 1 && item.attempted_option == optionItem.correct_options_id) {
                                                optionClass = 'list-group-item list-group-item-success'; 
                                            }

                                            if(item.attempted_status === 2 && item.attempted_option === optionItem.option_id) {
                                                optionClass = 'list-group-item list-group-item-danger'; 
                                            }
                                            
                                            if(item.attempted_status === 2 && typeof optionItem.correct_options_id !== 'undefined') {
                                                optionClass = 'list-group-item list-group-item-success'; 
                                            }
                                            
                                            return (
                                                <>
                                                    <li className={optionClass}>
                                                        <div dangerouslySetInnerHTML={{ __html: optionItem.option_english }} />
                                                        <div dangerouslySetInnerHTML={{ __html: optionItem.option_hindi }} />
                                                    </li>
                                                </>
                                            )
                                            
                                       })    
                                    }
                                    </ul>
                                    <hr/>

                                    { 
                                       (showExplanation == 1) ? (
                                        <>
                                            <div className="panel-group" id="accordion_3" role="tablist" aria-multiselectable="true">
                                                <div className="panel panel-warning">
                                                    <div className="panel-heading" role="tab" id="headingOne_3">
                                                        <h4 className="panel-title">
                                                            <a role="button" data-toggle="collapse" data-parent="#accordion_3" href="#collapseOne_3" aria-expanded="true" aria-controls="collapseOne_3">
                                                                Explanation (व्याख्या)
                                                            </a>
                                                        </h4>
                                                    </div>
                                                    <div id="collapseOne_3" className="panel-collapse collapse" role="tabpanel" aria-labelledby="headingOne_3">
                                                        <div className="panel-body">
                                                            <div dangerouslySetInnerHTML={{ __html: item.explanation_english }} />
                                                            <hr/>
                                                            <div dangerouslySetInnerHTML={{ __html: item.explanation_hindi }} />

                                                            <img src={item.explanation_image_url} width="100%"  />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <br/>
                                            <br/>
                                        </>
                                        ) : ( <> </> )
                                    }
                                </div> 
                            </div>
                            </>
                            )
                        })
                }     
            </div>
        </section>
        
        
        <div className="footerExam">
            <div className="row clearfix">
                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 borderRightWhite" onClick={() => handlePageChange(currentQuestion - 1)} >
                    <p className="previousClass">Previous</p>
                </div>    
                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6" onClick={() => handlePageChange(currentQuestion + 1)} > 
                    <p className="nextClass">Next</p> 
                </div>
            </div>    
        </div>
        </>
    );
   
}
    
export default ExamReportDetails;